import { CommonUtilsService } from 'util/services';
import { HelpBlurbDataStore } from 'sharebase/dataStores/help-blurb-datastore';

export const DAYS_UNTIL_EXPIRATION = 90;
export class HelpBlurb {
	public static $inject = [
		'utils',
		'sbHelpBlurbDataStore'
	];

	public viewedExpirationDate:Date;
	public storageKey:string;
	
	public get hasBeenViewed():boolean {
		return this.sbHelpBlurbDataStore.viewedHelpBlurbs[this.storageKey] ? true : false;
	};

	constructor(
		public text:string,
		public id:string,
		private readonly utils:CommonUtilsService,
		private sbHelpBlurbDataStore:HelpBlurbDataStore
	){
		this.storageKey = this.id ? this.id : this.utils.generateHash(this.text);

		if(this.hasBeenViewed) {
			//Extend the expiration date that is used to remove old blurbs that are no longer used
			this.markAsViewed();
		}
	}

	public markAsViewed() {
		let updatedViewedExpirationDate = new Date();
		updatedViewedExpirationDate.setDate(updatedViewedExpirationDate.getDate() + DAYS_UNTIL_EXPIRATION);

		this.viewedExpirationDate = updatedViewedExpirationDate;
		this.sbHelpBlurbDataStore.updateExpirationDate(this);
	}
}


// WEBPACK FOOTER //
// ./src/sharebase/domain/helpBlurb.ts